export const minPrice = (prices: number[]): number => (prices.length ? Math.min(...prices) : 0)

export const maxPrice = (prices: number[]): number => (prices.length ? Math.max(...prices) : 0)

export const avgPrice = (prices: number[]): number =>
    prices.length ? Math.floor(prices.reduce((sum, price) => sum + price, 0) / prices.length) : 0

export const medianPrice = (prices: number[]): number =>
    prices.length ? prices.slice().sort((price1, price2) => price1 - price2)[Math.floor(prices.length / 2)] : 0
